"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceLine = void 0;
var utils_1 = require("../../../utils");
var offer_1 = require("../offer");
var ServiceLine = /** @class */ (function (_super) {
    __extends(ServiceLine, _super);
    function ServiceLine() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ServiceLine.defaultProps = function (type, name, owner) {
        return __assign(__assign({}, offer_1.Offer.defaultProps(type, name, owner)), { owner: owner, businesses: [], variants: [], type: type, types: utils_1.TypeMapper.parentRelations(type, 'service'), externalAttributes: {}, internalAttributes: {} });
    };
    return ServiceLine;
}(offer_1.Offer));
exports.ServiceLine = ServiceLine;
